import { createContext, type ReactNode } from "react";
import texts from "../i18n/de.json";
import type { TextKey } from "../generated/text-keys";

interface TextContextValue {
    t: (key: TextKey|string) => string|null;
}

const TextContext = createContext<TextContextValue>({
    t: (key) => key
});

function resolveKey(obj: unknown, key: string): string | null {
    const result = key.split(".").reduce<unknown>((acc, part) => {
        if (!acc || typeof acc !== "object") {
            return undefined;
        }
        return (acc as Record<string, unknown>)[part];
    }, obj);

    return typeof result === "string" ? result : null;
}

interface TextProviderProps {
    children: ReactNode;
}

const TextProvider = ({ children }: TextProviderProps) => {
    const value: TextContextValue = {
        t: (key) => resolveKey(texts, key)
    };

    return (
        <TextContext.Provider value={value}>
            {children}
        </TextContext.Provider>
    );
}

export { TextContext, TextProvider };
